(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("signIn", {
        templateUrl: "app/security/signIn.component.html",
        controllerAs: "vm",
        controller: ["$window", "$location", "authService", "homePageService", "publicResource", "accountsResource", "messageService", "myAccountResource", "frameworkService", "sessionService", "shoppingCartService", "$cacheFactory", "$http", "$scope", "$rootScope", "$localStorage", "$state", "$uibModal", "$translate", "$timeout", SignInCtrl]
    });
    function SignInCtrl($window, $location, authService, homePageService, publicResource, accountsResource, messageService, myAccountResource, frameworkService, sessionService, shoppingCartService, $cacheFactory, $http, $scope, $rootScope, $localStorage, $state, $uibModal, $translate, $timeout) {
        var vm = this;
        //2024-12-03 - don't think this can happen now that navbar is angular
        if ($state.current.name === "main.signOut") {
            sessionService.destroy();
            $cacheFactory.get("$http").removeAll();
            authService.logOut().then(function () {
                $state.go("main.signIn");
            });
            return;
        }
        vm.loading = true;
        vm.signingIn = false;
        vm.frameworkData = frameworkService.data;
        vm.emailConfirmed = true;
        vm.showErrors = false;
        vm.sending = false;
        vm.redirecting = false;
        vm.externalProviders = [];
        vm.superAdminSignIn = $state.params.superAdminSignIn;
        vm.checkout = $state.current.name === "main.checkout.step1";
        vm.isAuth = authService.authentication.isAuth;
        if (vm.isAuth)
            vm.name = authService.authentication.userFirstName + " " + authService.authentication.userLastName;
        frameworkService.updateData();
        vm.logoUrl = angular.copy(vm.frameworkData.tenant.logoUrl);
        vm.bigLogoUrl = angular.copy(vm.frameworkData.tenant.bigLogoUrl);
        //angular.forEach($cacheFactory.info(), function (_ob, key) {
        //	$cacheFactory.get(key).removeAll();
        //});
        vm.redirecting = CheckLocationHash();
        if (!vm.redirecting) {
            if (vm.frameworkData.tenant.id > 0 && !vm.frameworkData.tenant.hasSignIn && !vm.superAdminSignIn) {
                return;
            }
            //WHEN IS THIS TRUE?
            //if (authService.authentication.isAuth && authService.authentication.emailConfirmed) {
            //	var expiresIn = new Date(authService.getTokenExpiryDate()).getTime() - new Date().getTime();
            //	if (expiresIn > 0) {
            //		$scope.$emit("checkSubscription");
            //		$rootScope.$broadcast("signInComplete");
            //		vm.redirecting = true;
            //		frameworkService.updateData();
            //		homePageService.loadSignedInHomePage();
            //		return;
            //	}
            //}
            if (!authService.authentication.isAuth) {
                if ($localStorage.token)
                    delete $localStorage.token;
                if ($localStorage.rememberMeData) {
                    vm.userName = $localStorage.rememberMeData.userName;
                    vm.rememberMe = true;
                }
                loadExternalProviders();
            }
        }
        function CheckLocationHash() {
            if (!location.hash)
                return false;
            if (location.hash.indexOf("access_token") < 0 || !location.hash.split("access_token="))
                return false;
            var accessToken = location.hash.split("access_token=")[1].split("&")[0];
            if (!accessToken)
                return false;
            var expiresIn = new Date(decodeURIComponent(location.hash.split("expires_in=")[1].split("&")[0]));
            //TODO: FL Move to authservice
            var request = {
                method: "GET",
                url: "api/Accounts/UserInfo",
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + accessToken
                }
            };
            //HAL uses this. Other SSO as well?
            $http(request).then(function (response) {
                if (response.data.hasRegistered) {
                    if (!location.hash.split("refresh_token=") || !location.hash.split("refresh_token=")[1])
                        return;
                    var refreshToken = location.hash.split("refresh_token=")[1].split("&")[0];
                    if (!refreshToken)
                        return;
                    delete $localStorage.storefrontCart3;
                    $rootScope.$broadcast("updateShoppingCartCount", 0);
                    //authorize the user
                    var data = response.data;
                    data.token = accessToken;
                    data.tokenExpires = expiresIn;
                    data.access_token = accessToken;
                    data.refresh_token = refreshToken;
                    data[".expires"] = expiresIn;
                    authService.setAuthenticationData(data);
                    var currentCulture = $translate.proposedLanguage() || $translate.use();
                    if (currentCulture !== $localStorage.selectedLanguage.culture)
                        $translate.use($localStorage.selectedLanguage.culture).then(function () { $translate.refresh(); }); //Fix: https://github.com/angular-translate/angular-translate/issues/1781
                    processSignIn();
                }
                else {
                    //Redirect to Sign Up if self registration is on
                    if (vm.frameworkData.tenant.tenantFeaturesSelfRegistrationEnabled) {
                        $localStorage.token = accessToken;
                        $state.go("main.selfRegistration");
                    }
                    else {
                        messageService.error("signIn.error.noAccountLinked");
                        vm.redirecting = false;
                    }
                }
            }, function (error) {
                messageService.error(error);
            });
            return true;
        }
        vm.signInExternal = function (url) {
            vm.signingIn = true;
            location.href = url;
        };
        vm.signIn = function ($event) {
            if (vm.form.$valid) {
                messageService.closeAll();
                $event.preventDefault();
                vm.signingIn = true;
                vm.loginData = {
                    checkout: vm.checkout,
                    userName: vm.userName,
                    password: vm.password,
                    tenantId: vm.frameworkData.tenant.id,
                    tenantCode: vm.frameworkData.tenant.code,
                    rememberMe: vm.rememberMe
                };
                if (authService.authentication.isAuth) {
                    sessionService.destroy();
                    authService.logOut().then(function () {
                        login();
                    });
                }
                else {
                    login();
                }
            }
            else {
                vm.showErrors = true;
                vm.signingIn = false;
            }
        };
        function login() {
            //clear all local/session storage including DataTables_ - CURRENTLY THIS DOES NOT EFFECT $localStorage (shoppingCart)
            if (sessionStorage)
                sessionStorage.clear();
            //if (localStorage)
            //	localStorage.clear();
            authService.login(vm.loginData).then(function () {
                processSignIn();
            }, function (error) {
                messageService.error(error);
                $timeout(function () {
                    vm.signingIn = false;
                }, 1000);
            });
        }
        var processSignIn = function () {
            if (vm.checkout) {
                sessionService.init();
                frameworkService.updateData();
                shoppingCartService.clearServerCart(function () {
                    shoppingCartService.synchronizeShoppingCart(function (hasAssignedPath) {
                        if (hasAssignedPath)
                            $state.go("main.shoppingCart");
                        else if ($localStorage.storefrontCart3.cartItems && $localStorage.storefrontCart3.cartItems.length > 0)
                            $state.go("main.checkout.step1", {}, { reload: true });
                        else
                            $state.go("main.storefrontCatalog");
                    });
                });
                return;
            }
            vm.emailConfirmed = authService.authentication.emailConfirmed;
            if (vm.emailConfirmed) {
                sessionService.init();
                $scope.$emit("checkSubscription");
                myAccountResource.isUserMissingRequiredRegistrationFields(function (data) {
                    authService.authentication.isMissingRegistrationData = data.value;
                    authService.saveAuthenticationDataToLocalStorage();
                    frameworkService.updateData();
                    $rootScope.$broadcast("reloadMenu");
                    if (frameworkService.data.tenantFeatures.storefront) {
                        shoppingCartService.synchronizeShoppingCart();
                    }
                    vm.redirecting = true;
                    if ($rootScope.signinRedirect) {
                        if ($rootScope.signinRedirect.toState)
                            $state.go($rootScope.signinRedirect.toState, $rootScope.signinRedirect.toParams);
                        //LF - we'll do this in angular app.component.ts for now
                        //else if ($rootScope.signinRedirect.toUrl) {
                        //	setTimeout(() => {
                        //		$location.path($rootScope.signinRedirect.toUrl);
                        //	},100);
                        //}
                        //delay removing this
                        setTimeout(function () {
                            $rootScope.signinRedirect = null;
                        }, 1000);
                    }
                    else {
                        //this is done with broadcast now after angular fill auth data
                        //homePageService.loadSignedInHomePage();
                    }
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                vm.redirecting = false;
                vm.signingIn = false;
            }
        };
        vm.resendAccountVerificationEmail = function () {
            if (vm.form.$valid) {
                messageService.closeAll();
                vm.sending = true;
                var model = {
                    tenantId: vm.frameworkData.tenant.id,
                    userName: vm.userName
                };
                publicResource.resendEmailVerificationEmail(model, function () {
                    vm.emailConfirmed = true; //temp to hide the section for email verification
                    vm.showErrors = false;
                    vm.sending = false;
                    messageService.success("signIn.resendVerificationEmail.success");
                }, function (error) {
                    messageService.error(error);
                    vm.sending = false;
                });
            }
            else {
                vm.showErrors = true;
                vm.sending = false;
            }
        };
        function loadExternalProviders() {
            accountsResource.getExternalLogins({ returnUrl: "/sign-in", generateState: true }, function (result) {
                vm.externalProviders = result;
            }, function (error) {
                messageService.error(error);
            }).$promise.finally(function () {
                //EXAMPLE Finally then Translate onReady
                $translate.onReady().then(function () {
                    vm.loading = false;
                });
            });
        }
    }
}());
